<template>
  <div
    :class="[siteConfigColor == 'black' ? 'site_config_color' : '', 'plugin-wrapper', 'layout', 'image-swiper', 'swiper' + _uid]"
    v-if="config && Array.isArray(config.nodes) && config.nodes.length">
    <swiper class="swiper-x-container" :ref="'iSwiper' + _uid" :options="swiperOpts" @slideChange="transitionEnd">
      <swiper-slide class="swiper-x-item" v-for="(item, index) in config.nodes" :key="index">
        <template v-if="item.tag == 'image'">
          <!-- <img :src="item.src.pc" class="show-for-md swiper-item__image image__fit" @click="actionHandler(item.action)" alt="Sisley Paris" />
          <img :src="item.src.h5" class="hide-for-md swiper-item__image image__fit" @click="actionHandler(item.action)" alt="Sisley Paris" /> -->
          <picture>
            <source media="(min-width: 1024px)"
              :srcset="item.src.pc + '?x-oss-process=image/resize,w_1200/quality,q_95'">
            <source media="(min-width: 0)" :srcset="item.src.h5 + '?x-oss-process=image/resize,w_750/quality,q_95'">
            <div @click="actionHandler(item.action)">
              <img class="swiper-item__image image__fit on-prevent"
                :src="(winW ? item.src.pc : item.src.h5) + '?x-oss-process=image/resize,w_1200/quality,q_95'" alt />
            </div>
          </picture>
          <template v-if="item.h5_hots && !winW">
            <HotItem :hotsitem="item.h5_hots" type="h5"></HotItem>
          </template>
          <template v-if="item.pc_hots && winW">
            <HotItem :hotsitem="item.pc_hots" type="pc"></HotItem>
          </template>
        </template>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div :class="['swiper-button-prev', siteConfigColor == 'black' ? 'swiper-button-black' : 'swiper-button-white']"
        slot="button-prev"></div>
      <div :class="['swiper-button-next', siteConfigColor == 'black' ? 'swiper-button-black' : 'swiper-button-white']"
        slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import actionMixins from "@/utils/action.mixins";
import HotItem from "@/components/HotItem.vue";

export default {
  name: 'ImageSwiper',
  mixins: [actionMixins],
  components: { swiper, swiperSlide, HotItem },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      iSwiper: {},
      swiperOpts: {
        autoplay: true,
        loop: true,
        // loopedSlides: this.config.nodes.length + 2,
        speed: 1000,
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          // dynamicBullets: true,
          bulletClass: "swiper-bullet",
          bulletActiveClass: "swiper-bullet__active",
          clickable: true
        },
        navigation: {
          prevEl: `.swiper${this._uid} .swiper-button-prev`,
          nextEl: `.swiper${this._uid} .swiper-button-next`
        },
        on: {
          slideChangeTransitionEnd() {
            this.slideToLoop(this.realIndex, 0, false);
          }
        }
      },
      siteConfigColor: 'black'
    }
  },
  mounted() {
    this.iSwiper = this.$refs?.[`iSwiper` + this._uid]?.swiper;
  },
  created() {
    this.siteConfigColor = this.config?.nodes[0].theme
    console.log(this.config.nodes)
  },
  computed: {
    winW() { return window.innerWidth > 1024; },
  },
  methods: {
    transitionEnd() {
      this.siteConfigColor = this.config.nodes[this.iSwiper.realIndex].theme
    },
  }
}
</script>

<style lang="scss" scoped>
.image-swiper {
  box-sizing: border-box;
  width: 100%;
  margin-top: -0.5px;

  .swiper-x-container {
    width: 100%;
    height: 100%;
  }

  .swiper-item__image {
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
    cursor: pointer;
  }

  & /deep/ .swiper-bullet {
    display: inline-block;
    height: 16px;
    width: 16px;
    margin: 0 4px;
    opacity: 1;
    cursor: pointer;
    background: 0 0;
    border-radius: 100%;
    transform: translate3d(0, 0, 0) scaleX(1);

    &::before {
      content: '';
      display: block;
      height: 100%;
      width: 100% !important;
      position: absolute;
      top: 50%;
      left: 50%;
      cursor: pointer;
      -webkit-transform: translate3d(-50%, -50%, 0) scale(0);
      -moz-transform: translate3d(-50%, -50%, 0) scale(0);
      transform: translate3d(-50%, -50%, 0) scale(0);
      border: 1px solid #fff;
      -webkit-transition: -webkit-transform .5s cubic-bezier(.175, .885, .32, 1.275);
      -o-transition: -o-transform .5s cubic-bezier(.175, .885, .32, 1.275);
      -moz-transition: transform .5s cubic-bezier(.175, .885, .32, 1.275), -moz-transform .5s cubic-bezier(.175, .885, .32, 1.275);
      transition: transform .5s cubic-bezier(.175, .885, .32, 1.275);
      transition: transform .5s cubic-bezier(.175, .885, .32, 1.275), -webkit-transform .5s cubic-bezier(.175, .885, .32, 1.275), -moz-transform .5s cubic-bezier(.175, .885, .32, 1.275), -o-transform .5s cubic-bezier(.175, .885, .32, 1.275);
      border-radius: 50%;
      background-color: transparent
    }

    &::after {
      content: '';
      display: block;
      width: 5px;
      height: 5px;
      position: absolute;
      top: 50%;
      left: 50%;
      background: #fff;
      -webkit-transition: opacity .5s, -webkit-transform .5s cubic-bezier(.175, .885, .32, 1.275);
      -o-transition: opacity .5s, -o-transform .5s cubic-bezier(.175, .885, .32, 1.275);
      -moz-transition: transform .5s cubic-bezier(.175, .885, .32, 1.275), opacity .5s, -moz-transform .5s cubic-bezier(.175, .885, .32, 1.275);
      transition: transform .5s cubic-bezier(.175, .885, .32, 1.275), opacity .5s;
      transition: transform .5s cubic-bezier(.175, .885, .32, 1.275), opacity .5s, -webkit-transform .5s cubic-bezier(.175, .885, .32, 1.275), -moz-transform .5s cubic-bezier(.175, .885, .32, 1.275), -o-transform .5s cubic-bezier(.175, .885, .32, 1.275);
      -webkit-transform: translate3d(-50%, -50%, 0);
      -moz-transform: translate3d(-50%, -50%, 0);
      transform: translate3d(-50%, -50%, 0);
      border-radius: 50%;
      opacity: 1
    }

    &.swiper-bullet__active {
      &:after {
        -webkit-transform: translate3d(-50%, -50%, 0) scale(0);
        -moz-transform: translate3d(-50%, -50%, 0) scale(0);
        transform: translate3d(-50%, -50%, 0) scale(0);
        opacity: 0;
      }
    }

    &.swiper-bullet__active:before,
    &:hover:before {
      -webkit-transform: translate3d(-50%, -50%, 0) scale(.7);
      -moz-transform: translate3d(-50%, -50%, 0) scale(.7);
      transform: translate3d(-50%, -50%, 0) scale(.7);
    }
  }
}

.site_config_color {
  & /deep/ .swiper-bullet {
    display: inline-block;
    height: 16px;
    width: 16px;
    margin: 0 4px;
    opacity: 1;
    cursor: pointer;
    background: 0 0;
    border-radius: 100%;
    transform: translate3d(0, 0, 0) scaleX(1);

    &::before {
      content: '';
      border: 1px solid #000;
    }

    &::after {
      content: '';
      background: #000;
    }
  }
}
</style>